import React from 'react'

import { connect } from 'react-redux'
import _each from 'lodash/each'

import BasePureComponent from 'utils/BasePureComponent'
import request from 'utils/request'

import FileInput from 'components/InputFile'
import Button from 'components/Button'

import {
  nextStep,
  prevStep,
  updateDatasetValue,
} from 'scenes/ClientDetail/components/AddVehicleModal/actions'
import { DOCUMENTS_DATASET } from 'scenes/ClientDetail/components/AddVehicleModal/constants'

import { UPDATE_DOCUMENTS_URL } from 'constants'

import './style.scss'


const FILE_TYPE_MAPPING = {
  driver_license_file: 'LC',
  vehicle_card_file: 'TC',
  vehicle_invoice_file: 'FV'
}

export class DocumentsStep extends BasePureComponent {
  constructor(props) {
    super(props)

    this.state = {}
    this.FILES_TO_UPLOAD = 0
    this.UPLOADED_FILES = 0
    this._bind('_onFileChange', '_uploadFile', '_onContinue')
  }

  _uploadFile(file, type) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('type', type)

    request(UPDATE_DOCUMENTS_URL(this.props.clientId, this.props.vehicleId), {
      method: 'POST',
      isUpload: true,
      body: formData
    })
    .then(() => {
      this.UPLOADED_FILES += 1
      if (this.FILES_TO_UPLOAD === this.UPLOADED_FILES)
        this.props.nextStep()
    })
    .catch(console.log)
  }

  _onContinue(evt) {
    evt.preventDefault()

    const files = this.props.data

    _each(files, ( file, name ) => {
      if ( !file ) return

      this.FILES_TO_UPLOAD += 1
      const fileType = FILE_TYPE_MAPPING[name]
      this._uploadFile(file, fileType)
    })

    if ( this.FILES_TO_UPLOAD === 0)
      this.props.nextStep()
  }

  _onFileChange(e) {
    const file = e.target.files.length ? e.target.files[0] : null
    this.props.updateDatasetValue(e.target.name, file)
  }

  render() {
    return (
      <section className="DocumentsDataStep">
        <div className="DocumentsDataStep__inputs">
          <FileInput
            file={this.props.data.driver_license_file}
            label="Archivo licencia de conducir"
            name="driver_license_file"
            onChange={this._onFileChange}
          />
          <FileInput
            file={this.props.data.vehicle_card_file}
            label="Archivo tarjeta de circulación"
            name="vehicle_card_file"
            onChange={this._onFileChange}
          />
          <FileInput
            file={this.props.data.vehicle_invoice_file}
            label="Archivo factura del vehículo"
            name="vehicle_invoice_file"
            onChange={this._onFileChange}
          />
        </div>
        <hr />
        <div className="DocumentsDataStep__footer">
          <Button buttonType="primary-inverse" onClick={this.props.prevStep}>Regresar</Button>
          <Button onClick={this._onContinue}>Continuar</Button>
        </div>
      </section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentStep: state.addVehicleModal.get('currentStep'),
    vehicleId: state.addVehicleModal.get('vehicleId'),
    data: state.addVehicleModal.get(DOCUMENTS_DATASET).toJS()
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    nextStep: () => dispatch(nextStep()),
    prevStep: () => dispatch(prevStep()),
    updateDatasetValue: (name, value) => dispatch(updateDatasetValue(DOCUMENTS_DATASET, name, value)),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(DocumentsStep)



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/components/AddVehicleModal/DocumentsStep/index.js